import DictUtil from '@/utils/dict-utils'

// 专家抽取规则
export const expertExtractRuleDict = new DictUtil({
  RANDOM: {
    label: '随机抽取',
    value: 1
  },
  MANUAL: {
    label: '手动抽取',
    value: 2
  }
})

// 专家是否展示
export const expertShowDict = new DictUtil({
  YES: {
    label: '展示',
    value: 1
  },
  NO: {
    label: '隐藏',
    value: 2
  }
})

// 抽取规则字典
export const extractRuleDict = new DictUtil({
  RANDOM_HIDE: {
    label: '随机抽取并隐藏专家',
    value: `${expertExtractRuleDict.RANDOM.value}-${expertShowDict.NO.value}`
  },
  RANDOM_SHOW: {
    label: '随机抽取并查看专家',
    value: `${expertExtractRuleDict.RANDOM.value}-${expertShowDict.YES.value}`
  },
  MANUAL: {
    label: '手动选择专家',
    value: `${expertExtractRuleDict.MANUAL.value}-${expertShowDict.YES.value}`
  }
})

// 通知方式
export const extractNoticeTypeDict = new DictUtil({
  OFFLINE: {
    label: '线下通知',
    value: 2
  },
  INLINE: {
    label: '自动线上通知',
    value: 1
  }
})

// 专家入库审核状态
export const expertCertificateStatusDict = new DictUtil({
  TO_AUDIT: {
    label: '待审核',
    value: 0,
    type: 'primary'
  },
  PASS: {
    label: '审核通过',
    value: 1,
    type: 'success'
  },
  REFUSE: {
    label: '审核不通过',
    value: 2,
    type: 'danger'
  }
})

// 专家入库审核操作
export const expertAuditDict = new DictUtil({
  PASS: {
    label: '通过',
    value: 1
  },
  REFUSE: {
    label: '驳回',
    value: 2
  }
})

// 性别
export const sexDict = new DictUtil({
  MAN: {
    label: '男',
    value: 1
  },
  WOMAN: {
    label: '女',
    value: 2
  }
})

// 专业状态
export const majorStatusDict = new DictUtil({
  ENABLE: {
    label: '启用',
    value: 1,
    type: 'success'
  },
  DISABLE: {
    label: '禁用',
    value: 2,
    type: 'danger'
  }
})

// 职称
export const jobTitleDict = new DictUtil({
  1: { label: '高级工程师', value: 1 },
  2: { label: '高级经济师', value: 2 },
  3: { label: '工程师', value: 3 },
  4: { label: '经济师', value: 4 },
  5: { label: '助理经济师', value: 5 },
  6: { label: '教授', value: 6 },
  7: { label: '副教授', value: 7 },
  8: { label: '高级讲师', value: 8 },
  9: { label: '讲师', value: 9 },
  10: { label: '高级会计师', value: 10 },
  11: { label: '会计师', value: 11 },
  12: { label: '助理会计师', value: 12 },
  13: { label: '高级工艺美术师', value: 13 },
  14: { label: '高级审计师', value: 14 },
  15: { label: '助理工程师', value: 15 },
  16: { label: '高级建筑师', value: 16 },
  17: { label: '建筑师', value: 17 },
  18: { label: '技术员', value: 18 },
  19: { label: '研究院', value: 19 },
  20: { label: '教授级高工', value: 20 },
  21: { label: '无', value: 21 }
})

// 专家状态
export const expertStatusDict = new DictUtil({
  ENABLE: {
    label: '启用',
    value: 1,
    type: 'primary'
  },
  DISABLE: {
    label: '禁用',
    value: 2,
    type: 'danger'
  }
})

// 是否发放专家费用
export const isPayFeeDict = new DictUtil({
  YES: {
    label: '是',
    value: 1
  },
  NO: {
    label: '否',
    value: 2
  }
})

// 是否是采购人专家
export const isInsideExpertDict = new DictUtil({
  YES: {
    label: '是',
    value: 1
  },
  NO: {
    label: '否',
    value: 2
  }
})

// 通知状态
export const notifyStatusDict = new DictUtil({
  TO_NOTICE: {
    label: '待通知',
    value: 0,
    type: 'info'
  },
  NOTICING: {
    label: '通知中',
    value: 1,
    type: 'primary'
  },
  NOTICED: {
    label: '已通知',
    value: 2,
    type: 'success'
  },
  FAIL: {
    label: '通知失败',
    value: 3,
    type: 'warning'
  },
  NO_NEED: {
    label: '无需通知',
    value: 4,
    type: 'info'
  }
})

// 回复状态
export const replyStatusDict = new DictUtil({
  TO_REPLAY: {
    label: '待回复',
    value: 0,
    type: 'info'
  },
  ACCEPTED: {
    label: '确定参加',
    value: 1,
    type: 'success'
  },
  REFUSE: {
    label: '拒绝参加',
    value: 2,
    type: 'danger'
  },
  NO_REPLAY: {
    label: '对方无应答',
    value: 3,
    type: 'warning'
  }
})

// 到场状态
export const presentStatusDict = new DictUtil({
  YES: { label: '确认到场', value: 1, type: 'success' },
  NO: { label: '无法到场', value: 2, type: 'danger' }
})

// 抽取通知回复状态
export const noticeReplyStatusDict = new DictUtil({
  ACCEPTED: {
    label: '已通知-确认参加',
    value: `${notifyStatusDict.NOTICED.value}-${replyStatusDict.ACCEPTED.value}`,
    type: 'success'
  },
  REFUSE: {
    label: '已通知-拒绝参加',
    value: `${notifyStatusDict.NOTICED.value}-${replyStatusDict.REFUSE.value}`,
    type: 'danger'
  },
  NO_REPAY: {
    label: '已通知-对方无应答',
    value: `${notifyStatusDict.NOTICED.value}-${replyStatusDict.NO_REPLAY.value}`,
    type: 'warning'
  },
  TO_NOTICE: {
    label: '尚未通知',
    value: `${notifyStatusDict.TO_NOTICE.value}-${replyStatusDict.TO_REPLAY.value}`,
    type: 'primary'
  }
})

// 抽取通知回复状态(4-0)
export const noticeReplyEndStatusDict = new DictUtil({
  ACCEPTED: {
    label: '已通知-确认参加',
    value: `${notifyStatusDict.NOTICED.value}-${replyStatusDict.ACCEPTED.value}`,
    type: 'success'
  },
  REFUSE: {
    label: '已通知-拒绝参加',
    value: `${notifyStatusDict.NOTICED.value}-${replyStatusDict.REFUSE.value}`,
    type: 'danger'
  },
  NO_REPAY: {
    label: '已通知-对方无应答',
    value: `${notifyStatusDict.NOTICED.value}-${replyStatusDict.NO_REPLAY.value}`,
    type: 'warning'
  },
  TO_NOTICE: {
    label: '尚未通知',
    value: `${notifyStatusDict.NO_NEED.value}-${replyStatusDict.TO_REPLAY.value}`,
    type: 'primary'
  }
})

// 抽取通知回复状态
export const noticeReplyStatusShowDict = new DictUtil({
  ACCEPTED: {
    label: '已通知-确认参加',
    value: `${notifyStatusDict.NOTICED.value}-${replyStatusDict.ACCEPTED.value}`,
    type: 'success'
  },
  REFUSE: {
    label: '已通知-拒绝参加',
    value: `${notifyStatusDict.NOTICED.value}-${replyStatusDict.REFUSE.value}`,
    type: 'danger'
  },
  NO_REPAY: {
    label: '已通知-对方无应答',
    value: `${notifyStatusDict.NOTICED.value}-${replyStatusDict.NO_REPLAY.value}`,
    type: 'warning'
  },
  NO_NEED_NOTICE: {
    label: '无需通知',
    value: `${notifyStatusDict.NO_NEED.value}-${replyStatusDict.TO_REPLAY.value}`,
    type: 'primary'
  },
  TO_NOTICE: {
    label: '尚未通知',
    value: `${notifyStatusDict.TO_NOTICE.value}-${replyStatusDict.TO_REPLAY.value}`,
    type: 'primary'
  }
})

// 通知结果状态
export const notifyResultStatusDict = new DictUtil({
  TO_NOTICE: {
    label: '待通知',
    value: 0,
    type: 'info'
  },
  UN_NOTICE: {
    label: '未通知',
    value: 1,
    type: 'primary'
  },
  NOTICING: {
    label: '通知中',
    value: 2,
    type: 'warning'
  },
  NOTICED: {
    label: '已结束',
    value: 3,
    type: 'success'
  }
})

// 抽取状态
export const extractStatusDict = new DictUtil({
  EXTRACTING: {
    label: '抽取中',
    value: 1,
    type: 'primary'
  },
  SUCCESS: {
    label: '抽取成功',
    value: 2,
    type: 'success'
  },
  FAIL: {
    label: '抽取失败',
    value: 3,
    type: 'danger'
  }
})

// 抽取类型（适用哪种项目）
export const extractToProjectDict = new DictUtil({
  BID: { label: '评审抽取', value: 1 },
  PERFORMANCE_PLAN: { label: '验收抽取', value: 2 }
})

// 抽取类型
export const extractTypeDict = new DictUtil({
  ORIGIN: {
    label: '抽取专业',
    value: 0
  },
  SUPPLEMENT: {
    label: '补抽专业',
    value: 1
  }
})

// 专家费审核状态
export const extractFeeAuditDict = new DictUtil({
  AUDITING: {
    label: '审批中',
    value: 1,
    type: 'primary'
  },
  PASS: {
    label: '审批通过',
    value: 2,
    type: 'success'
  },
  REJECT: {
    label: '审批驳回',
    value: 3,
    type: 'danger'
  }
})

// 专家认证状态
export const expertAuthStatusDict = new DictUtil({
  YES: { label: '已认证', value: 1, type: 'success' },
  NO: { label: '未认证', value: 0, type: 'danger' }
})

// 专家任务状态
export const expertTaskStatusDict = new DictUtil({
  YES: { label: '已创建', value: 1, type: 'success' },
  NO: { label: '未创建', value: 0, type: 'danger' }
})

// 专家支付状态
export const expertFeePayStatusDict = new DictUtil({
  NO: { label: '未支付', value: 0, type: 'info' },
  PAYING: { label: '支付中', value: 1, type: 'primary' },
  SUCCESS: { label: '支付成功', value: 2, type: 'success' },
  FAIL: { label: '支付失败', value: 3, type: 'danger' }
})
